/* eslint-disable jira/filename-case */
import { getLocation } from '@jira/ssr__browser-globals/src/getLocation.tsx';
import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

declare global {
	interface Window {
		/**
		 * disables stability render in development mode
		 */
		disableStabilityCheck(): void;

		/**
		 * runs (or enables) stability render in dev mode
		 * See {@link import('@jira/platform__test-utils-stability-control/src/activateStabilityRuntime.tsx').activateStabilityRuntime} for details
		 */
		runStabilityCheck(): void;
	}
}
if (
	// disable this feature for production mode
	process.env.NODE_ENV !== 'production'
) {
	// save to prevent mutations
	// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
	const ss = sessionStorage;
	const ACTIVATION_KEY = 'dev:stabilityCheck';

	// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
	if (sessionStorage.getItem(ACTIVATION_KEY)) {
		const {
			activateStabilityRuntime,
			// oxlint-disable-next-line typescript/no-require-imports
		} = require('@jira/platform__test-utils-stability-control/src/activateStabilityRuntime.tsx');

		// activate stability
		activateStabilityRuntime();

		// oxlint-disable-next-line no-console
		console.warn('⚠️ STABILITY CHECK IS ACTIVE ⚠️. To deactivate enter `disableStabilityCheck();`');
		const browserWindow = getWindow();
		if (browserWindow) {
			browserWindow.disableStabilityCheck = () => {
				ss.removeItem(ACTIVATION_KEY);
				// oxlint-disable-next-line no-console
				console.log('Stability check disabled. Reloading...');
				getLocation()?.reload();
			};
		}
	} else {
		const browserWindow = getWindow();
		if (browserWindow) {
			browserWindow.runStabilityCheck = () => {
				// oxlint-disable-next-line no-console
				console.log('Stability check is not yet active. Reloading...');
				ss.setItem(ACTIVATION_KEY, 'true');
				getLocation()?.reload();
			};
		}
	}
}
